import axios, { AxiosResponse } from 'axios';

interface OperatorsWithOnlineBillingResponse {
    GetTourOperatorsWithOnlineBillingResult: {
        Data: number[] | null;
        IsError: boolean;
        ErrorMessage: null | string;
        ErrorCode: number;
        ExecutionTimeMs: number;
    };
}
export async function getAvailableOperatorsForOnlineBilling(host: string, countryId: number): Promise<number[]> {
    try {
        const response: AxiosResponse<OperatorsWithOnlineBillingResponse> = await axios.get(
            `https://${host}/Services/GetTourOperatorsWithOnlineBilling.ashx?countryId=${countryId}`
        );

        const result = response.data.GetTourOperatorsWithOnlineBillingResult;

        if (result.IsError && result.ErrorMessage) {
            throw new Error(`${result.ErrorMessage} Error code: ${result.ErrorCode}`);
        }

        if (result.Data) return result.Data;

        return [];
    } catch (err) {
        throw err;
    }
}
